import React from "react";
import { useParams } from "react-router-dom";
import { useFinalPricePredictions } from "../../hooks/pricePredictions.hooks";
import { LoaderCentered } from "../../components/loaders/LoaderCentered";
import { TransparencyAdjustmentsCorrection } from "./TransparencyAdjustmentsCorrection";
import { TransparencySimilarity } from "./TransparencySimilarity";
import { useScrollToTop } from "../../hooks/router.hooks";
import { useQuery } from "react-query";
import { getPricePredictionsForTransparency } from "../../api/api";
import { useProperty } from "../../hooks/property.hooks";

interface PricePredictionsTransparencyRouteProps {}

export const PricePredictionsTransparencyRoute: React.FC<
  PricePredictionsTransparencyRouteProps
> = () => {
  const { propertyId } = useParams();

  const { data, isLoading } = useQuery(
    ["transparency_predictions", propertyId],
    () => getPricePredictionsForTransparency(propertyId ?? "")
  );

  const { data: property, isLoading: isPropertyLoading } = useProperty(
    propertyId ?? ""
  );

  useScrollToTop();

  if (isLoading || isPropertyLoading) {
    return <LoaderCentered />;
  }

  if (!data || !property) {
    return null;
  }

  return (
    <div>
      <TransparencyAdjustmentsCorrection data={data} />
      <TransparencySimilarity
        comparablesForReview={data.comparablesForReview}
        appliedFilters={data.applied_filters}
        property={property}
      />
    </div>
  );
};
